// Generated by LiveScript 1.6.0
var registerTemplates, loadTemplateFile;
registerTemplates = function(rootEl){
  var root;
  root = rootEl || document;
  return Array.from(root.querySelectorAll('template[name]')).forEach(function(tpl){
    var name, tag;
    name = tpl.getAttribute('name');
    if (name != null) {
      tag = name.toLowerCase();
      if (!customElements.get(tag)) {
        return customElements.define(tag, class extends HTMLElement {
          constructor() {
            super();
            var shadow = this.attachShadow({ mode: 'open' });
            document.getElementsByTagName('style').forEach(function(s) { shadow.appendChild(s.cloneNode(true)); });
            document.querySelectorAll('link[rel="stylesheet"]').forEach(function(l) { shadow.appendChild(l.cloneNode(true)); });
            tpl.content.childNodes.forEach(function(c) { shadow.appendChild(c.cloneNode(true)); });
          }
        });
      }
    }
  });
};
loadTemplateFile = function(file){
  return fetch(file).then(function(r){
    if (!r.ok) {
      throw new Error("HTTP " + r.status);
    }
    return r.text();
  }).then(function(html){
    var wrapper;
    wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    return registerTemplates(wrapper);
  })['catch'](function(e){
    return console.error('[entropy] Failed to load template:', e);
  });
};
module.exports = {
  registerTemplates: registerTemplates,
  loadTemplateFile: loadTemplateFile
};